/** Four service-adjacent siblings for each industry detail page. */
export const RELATED_INDUSTRIES: Record<string, readonly string[]> = {
  roofing: ["general-contractors", "remodeling", "window-replacement", "concrete"],
  painting: ["remodeling", "window-replacement", "general-contractors", "cleaning"],
  "pool-service": ["landscaping", "pest-control", "cleaning", "hardscape-drywall"],
  landscaping: ["tree-services", "hardscape-drywall", "pool-service", "concrete"],
  "general-contractors": ["construction", "remodeling", "window-replacement", "business-services"],
  "hardscape-drywall": ["landscaping", "concrete", "remodeling", "general-contractors"],
  "home-services": ["hvac", "plumbing", "electricians", "pest-control"],
  "tree-services": ["landscaping", "roofing", "concrete", "pest-control"],
  cleaning: ["home-services", "business-services", "tree-services", "pest-control"],
  construction: ["general-contractors", "business-services", "window-replacement", "marketing"],
  "business-services": ["construction", "marketing", "cleaning", "general-contractors"],
  "consumer-goods": ["food-beverage", "sports-fitness", "marketing", "business-services"],
  "food-beverage": ["consumer-goods", "sports-fitness", "marketing", "business-services"],
  "sports-fitness": ["consumer-goods", "food-beverage", "marketing", "business-services"],
  marketing: ["business-services", "construction", "consumer-goods", "food-beverage"],
  electricians: ["home-services", "hvac", "plumbing", "remodeling"],
  plumbing: ["hvac", "electricians", "home-services", "remodeling"],
  hvac: ["home-services", "plumbing", "electricians", "remodeling"],
  "pest-control": ["home-services", "cleaning", "landscaping", "tree-services"],
  concrete: ["construction", "landscaping", "hardscape-drywall", "remodeling"],
  remodeling: ["general-contractors", "window-replacement", "painting", "roofing"],
  "window-replacement": ["remodeling", "roofing", "painting", "tree-services"],
};